<template>
  <div>
    <base-card>
      <v-card-text>
        <div class="d-flex flex-column align-center justify-center text-center py-3">
          <h2 class="mb-5">Registro de Cliente y Autorización de Datos</h2>
          <p style="font-size: large !important;">Personalice el formulario de registro de clientes y defina su política de Habeas Data</p>
        </div>
      </v-card-text>
    </base-card>  
    <v-row justify="center" style="margin-left: 1% !important" class="mt-3">
      <v-layout class="overflow-visible" style="height: 56px">
        <v-bottom-navigation
          :elevation="24"
          v-model="selectedTab"
          color="rgb(204 33 40)"
          width="98% !important"
        >
          <v-btn value="config" class="nav-btn">
            1. Configuración de Formulario
          </v-btn>

          <v-btn value="inputConfig" class="nav-btn">
            2. Configuración de Campos
          </v-btn>

          <v-btn value="configEmail" class="nav-btn">
            3. Configuración plantilla correo
          </v-btn>

          <v-btn value="publication" class="nav-btn">
            4. Publicación y QR
          </v-btn>

        </v-bottom-navigation>
      </v-layout>
    </v-row>

    <base-card>
      <v-card-text class="mt-3">
        <div class="py-6">
          <component :is="currentComponent" />
        </div>
      </v-card-text>
    </base-card>
  </div>
</template>

<script>
import ConfigInputHabeasData from "@/views/app/invoices/components/ConfigInputHabeasData.vue";
import PublicationHabeasData from "@/views/app/invoices/components/PublicationHabeasData.vue";
import FormHabeasData from "@/views/app/invoices/components/FormHabeasData.vue";
import ConfigEmailHabeasData from "@/views/app/invoices/components/ConfigEmailHabeasData.vue";

export default {
  name: "HabeasDataManagement",
  data() {
    return {
      selectedTab: "config",
    };
  },
  computed: {
    currentComponent() {
      switch (this.selectedTab) {
        case "config":
          return FormHabeasData;
        case "publication":
          return PublicationHabeasData;
        case "configEmail":
          return ConfigEmailHabeasData;
        case "inputConfig":
          return ConfigInputHabeasData;
        default:
          return FormHabeasData;
      }
    },
  },
};
</script>
<style scoped>
.nav-btn {
  white-space: normal !important;
  line-height: 1.2;
  height: auto !important;
  min-width: 120px;
  text-align: center;
  max-width: -webkit-fill-available !important;
  font-size: unset !important;
}

</style>
